import React from "react";
var __jsx = React.createElement;
import ThreeColumnText from './ThreeColumnText';
function ThreeColumnTextAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(ThreeColumnText, {
    threeColumnTextData: entry
  });
}
export default ThreeColumnTextAdapter;